import { Component, OnInit , Input , Output, ElementRef , ViewChild, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-chrono',
  templateUrl: './chrono.component.html',
  styleUrls: ['./chrono.component.scss'],
})
export class ChronoComponent implements OnInit {

  @Input() duree : number;
  
  @Output() eventchild = new EventEmitter<string>();
 
  compteur = 0;
  texte : string;
  lancer = true;

  constructor() { }

  ngOnInit() {}

  ngAfterContentInit() {
    this.compteur=this.duree;
    //btvaliderquiz
    this.eventchild.emit("btvaliderquiz");   
    
    this.boucle();

  }

  boucle() {
    setTimeout(() => {
      if(this.lancer) {
      this.compteur--;
      this.texte = Math.trunc(this.compteur/60) + "min " + (this.compteur%60) + "s";
      if(this.compteur > 0) {
         this.boucle();   
      }
      else {
        this.lancer = false;
        this.eventchild.emit("changerquestion");   
     } 

      
      }  
    },1000);
  }

}
